export const valuePoints = [
  "Traduco problemi complessi in soluzioni software semplici da usare.",
  "Progetto architetture mantenibili, con costi e vincoli chiari.",
  "Scrivo codice pulito, leggibile e pronto per evolvere.",
  "Integro tecnologie moderne in modo pragmatico, senza complessita inutile.",
  "Seguo il progetto dalla progettazione al rilascio e al monitoraggio.",
];
